import * as React from 'react';
export const jeonbukSvg = React.forwardRef(function jeonbukSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M32 0H0v32h32V0Z',
      fill: '#0091D0',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm0 0 7.993 8.002L15.995 0H0Z',
      fill: '#0091D0',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 0v15.995l7.993-7.993L0 0Z',
      fill: '#009AD8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.995 15.995 8.002 7.993 0 15.995h15.995Z',
      fill: '#0091D0',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.995 15.995V0L8.002 7.993l7.993 8.002Z',
      fill: '#0082C9',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.995 0v15.995l8.003-7.993L15.995 0Z',
      fill: '#0071BB',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm32 15.995-8.002-8.002-7.993 8.002H32Z',
      fill: '#004C98',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm0 15.995 7.993 8.003 8.002-8.003H0Z',
      fill: '#0082C9',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 15.995V32l7.993-8.002L0 15.995Z',
      fill: '#0071BB',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.995 32-7.993-8.002L0 32h15.995Z',
      fill: '#0066B3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.995 32V16.005l-7.993 7.993L15.995 32Z',
      fill: '#00529C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.995 15.995 8.003 8.003L32 15.995H15.995Z',
      fill: '#1B3281',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.995 15.995V32l8.003-8.002-8.003-8.003Z',
      fill: '#004C98',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm32 32-8.002-8.002L16.005 32H32Z',
      fill: '#1B3281',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M32 32V16.005l-8.002 7.993L32 32Z',
      fill: '#1B3281',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.995 0 8.003 8.002L32 0H15.995Z',
      fill: '#0066B3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M32 15.995V0l-8.002 7.993L32 15.995Z',
      fill: '#00529C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm32 20.006-10.246-9.76L6.207 25.83l5.675 5.675 9.872-9.732L32 31.963V20.006Z',
      fill: '#fff',
    }),
  );
});
jeonbukSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var jeonbuk = {
  category: 'brand',
  colorable: false,
  name: 'jeonbuk',
  svg: jeonbukSvg,
};
